import { addZero } from '@sharedHelpers/addZero';
import { months } from '../../const/dateOptions';

export const getDateBySeconds = (seconds: number): string => {
  const date = new Date(seconds * 1000);
  return `${addZero(date.getDate())} ${months[date.getMonth()]} ${date.getFullYear()} г.`;
};
